import { Box, CircularProgress, Typography } from '@mui/material';
import { FC } from 'react';

interface LoadingProps {
  message?: string;
}

const Loading: FC<LoadingProps> = ({ message }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
      bgcolor: 'background.paper',
    }}
  >
    <CircularProgress />
    {message && <Typography sx={{ mt: 2 }}>{message}</Typography>}
  </Box>
);

Loading.defaultProps = {
  message: undefined,
};

export default Loading;
